import React from 'react';

import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import NextImage from '@src/components/Shared/NextImage';
import Container from '@src/components/Shared/Container';

import { SmartSpeedGridPropTypes, SmartSpeedItem } from './SmartSpeedGrid.types';

const GridItem = ({ item }: { item: SmartSpeedItem }) => (
  <div className='flex flex-col bg-background-tertiary px-[2.4rem] pt-[2.4rem] md:col-span-2 md:flex-row md:gap-x-[2rem] md:last:col-span-2 lg:col-span-1 lg:flex-col lg:last:flex lg:last:flex-row lg:last:items-center lg:last:py-[5rem] 2xl:px-[4.2rem] 2xl:pt-[4.2rem] lg:last:[&>div]:w-[50%]! 2xl:last:[&>div]:w-[48%]! lg:last:[&>figure]:w-[50%] 2xl:last:[&>figure]:w-[50%]'>
    <div className='md:flex md:w-[50%] md:flex-col md:justify-center lg:w-full'>
      <h3 className='mb-[3.2rem] text-[2.2rem] font-normal leading-none tracking-[-0.044rem] md:text-[2.2rem] md:tracking-[-0.044rem] lg:text-[3.2rem] lg:tracking-[-0.064rem] 2xl:mb-[3.2rem] 2xl:text-[3.2rem] 2xl:leading-none 2xl:tracking-[-0.064rem]'>
        {item?.title}
      </h3>
      <RenderBodyCopy
        className='mb-[0.8rem] text-[1.6rem] lg:mb-[2.4rem]'
        bodyCopy={item?.bodyCopy?.json?.content}
      />
    </div>
    <NextImage
      className='mt-auto md:w-[50%] lg:w-full 2xl:mx-auto 2xl:w-[40rem] 3xl:mx-auto 3xl:max-w-[60rem]'
      src={item?.mediaPrimary?.url}
      alt={item?.mediaPrimary?.description ?? 'VALD Image'}
      aspectRatio={item?.mediaPrimary?.width / item?.mediaPrimary?.height}
      width={item?.mediaPrimary?.width}
    />
  </div>
);

const SmartSpeedGrid: React.FC<SmartSpeedGridPropTypes> = ({ smartSpeed = [], id }) => {
  return (
    <Container
      attr='call-to-action-component'
      id={id}
      className='mx-auto grid gap-[1.6rem] md:grid-cols-2'
    >
      {smartSpeed?.map((item) => <GridItem key={`${item?.sys?.id}-smartspeed-grid`} item={item} />)}
    </Container>
  );
};
export default SmartSpeedGrid;
